/* eslint-disable max-len */
import DispatchersMixin from '@/mixins/dispatchers';

export default {
    name       : 'RelatedHistoric',
    mixins: [DispatchersMixin],
    /**
     * @override
     */
    data() {
        return {
            uuid_operation: null,
            relatedHistoric: []
        };
    },
    props: {
        type: {
            type: String,
            required: true
        },
        uuid: {
            type: String,
            required: true
        }
    },
    methods: {
        /**
         * Obtenemos la información relativa al historico del interviniente
         */
        fetchData() {

            let metodo;
            switch (this.type) {
                case 'operation':
                    metodo = this.$operationsService.getOperationHistoric;
                    break;
                case 'account':
                    metodo = this.$accountsService.getAccountHistoric;
                    break;
                case 'intervener':
                    metodo = this.$intervenersService.getIntervenerHistoric;
                    break;
                default:
                    return;
            }
            metodo(this.uuid, {}).then(res => {
                this.relatedHistoric.items = res.data.operations_historical || res.data.accounts_historical || res.data.intervener_historical || [];
            });
        },

        formatModification(item) {
            if (!item.data) return [];

            const { action, changed_fields } = item.data;

            if (!changed_fields?.length) return [];

            if (action === 'ACCOUNT_FISCAL_ADDRESS_UPDATED') {
                return changed_fields.map(field => ({
                label: 'Cambio de titular fiscal',
                old: field.oldValue?.name,
                new: field.newValue?.name
                }));
            }

            const fieldsToDisplay = action === 'CRS_UPDATED'
                ? changed_fields.filter(field => field.field !== 'crs.key_crs_country')
                : changed_fields;
            const hasMultipleCrsChanges = fieldsToDisplay.filter(field => field.field === 'crs').length > 1;

            return fieldsToDisplay.map(field => ({
                label: this.mapFieldName(field.field),
                hideLabel: field.field === 'crs',
                listItem: field.field === 'crs' && hasMultipleCrsChanges,
                old: this.formatFieldValue(field),
                new: this.formatFieldValue(field, 'newValue')
            }));
        },

        formatFieldValue(field, valueKey = 'oldValue') {
            const value = field[valueKey];
            if (value === null || value === undefined || value === '') return '-';

            if (field.field === 'crs') {
                let crsValue = value;

                if (typeof value === 'string') {
                    try {
                        crsValue = JSON.parse(value);
                    } catch (e) {
                        return value;
                    }
                }

                const tinCode = crsValue.tin_code || '-';
                const crsCountry = crsValue.key_crs_country ? this.$t(`countries.${crsValue.key_crs_country}`) : '-';

                return `${this.mapFieldName('tin_code')}: ${tinCode}, ${this.mapFieldName('key_crs_country')}: ${crsCountry}`;
            }

            if (field.field.includes('key_tin_issuer_country') || field.field.includes('key_crs_country')) {
                return this.$t(`countries.${value}`);
            }

            return value;
        },

        formatModificationTitle(action) {
            const translation = this.$t(`interveners.historical_actions.${action}`);
            return translation !== `interveners.historical_actions.${action}`
                ? translation
                : this.$t('interveners.historical_actions.default');
        },

        mapFieldName(fieldKey) {
            const cleanFieldKey = fieldKey.split('.').pop();
            const translation = this.$t(`headers.${cleanFieldKey}`);
            // Si no existe traduccion, i18n devuelve la key
            return translation !== `headers.${cleanFieldKey}` ? translation : fieldKey;
        }
    },
    /**
     * @override
     */
    beforeMount() {
        this.relatedHistoric = {
            fields: [
                {
                    key: 'created_on',
                    label: 'Fecha – Hora'
                },
                {
                    key: 'status',
                    label: 'Estado'
                },
                {
                    key: 'user_info',
                    label: 'Usuario'
                },
                {
                    key: 'modifications',
                    label: 'Modificaciones'
                }
            ],
            items: []
        };
        this.fetchData();
    }
};
